import { type ReactNode } from "react";
import Modal, { ModalRoot, ModalTrigger } from "@/components/Modal/Modal";
import { mergeClass } from "../utils/mergeClass";

export type CleModalSize = "default" | "sm";

export type CleModalProps = {
  children: ReactNode;
  className?: string;
  description?: string;
  dialog?: boolean;
  footer?: ReactNode;
  onErrorReset?: () => void;
  size?: CleModalSize;
  title?: ReactNode;
};

const CleModal = ({
  children,
  className,
  description,
  dialog,
  footer,
  onErrorReset,
  size = "default",
  title,
}: CleModalProps) => {
  return (
    <Modal
      className={mergeClass("cle-modal", className)}
      description={description}
      dialog={dialog}
      footer={footer}
      onErrorReset={onErrorReset}
      small={size === "sm"}
      title={title}
    >
      {children}
    </Modal>
  );
};

export { ModalRoot as CleModalRoot, ModalTrigger as CleModalTrigger };
export default CleModal;
